import {parseISO, setHours, isWithinInterval, startOfDay, endOfDay} from "date-fns";

export function parseDate(dateString: string | Date): Date {
  if (dateString instanceof Date) {
    return dateString;
  }
  const date = parseISO(dateString);
  return setHours(date, 16); // Set the time to 4 PM
}

export function isBetweenDatesInclusive(date: Date, startDate: Date, endDate: Date): boolean {
  return isWithinInterval(date, {
    start: startOfDay(startDate),
    end: endOfDay(endDate),
  });
}

export function formatDate(queryTitle: string, position: number): string {
  const datePart = queryTitle.split(', ')[position];
  const date = new Date(datePart);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: "UTC",
  };

  return date.toLocaleDateString('en-US', options);
}
